import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-314a83da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "message-container-align"
}
const _hoisted_3 = {
  key: 1,
  class: "container-fluid message-container-align"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 2,
  class: "container p-3",
  style: {"min-height":"363px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { href: "" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer15" }, null, -1))
const _hoisted_11 = ["state"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer10" }, null, -1))
const _hoisted_13 = { class: "d-flex align-items-start" }
const _hoisted_14 = {
  key: 0,
  class: "text-success mt-2 small"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle me-1" }, null, -1))
const _hoisted_16 = {
  key: 1,
  class: "text-danger mt-2 small"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer10" }, null, -1))
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = ["aria-disabled", "tabindex"]
const _hoisted_21 = {
  key: 0,
  class: "ms-3 text-muted small countdown-inline"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clock me-1" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer10" }, null, -1))
const _hoisted_24 = { class: "d-flex align-items-center mt-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer30" }, null, -1))
const _hoisted_26 = {
  id: "previousDownloads",
  class: "txtSize15"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer5" }, null, -1))
const _hoisted_28 = {
  id: "remainingDownloads",
  class: "txtSize15"
}

import { ref, watch, onMounted, computed } from "vue";
import VueCountdown from "@chenfengyuan/vue-countdown";
import CryptoJS from "crypto-js";
import router from "@/router";
import { useI18n } from "vue-i18n";
import axios from "axios";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { generateChecksum } from "../services/generateChecksum";
import { decryptData } from "../services/decryptData";
//import ErrorModal from "./ErrorModal.vue";
import Recaptcha from "./Recaptcha.vue";


const __default__ = {
  name: "OtpValidateComponent",
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const lastOtpErrorCode = ref("");
const otpErrorFlag = ref(false);
const otpSentFlag = ref(false);
const otp = ref("");
const otpState = ref<boolean | null>(null);
const otpError = ref("");
const otpErrorMessage = ref("");
const otpPopUpErrorMessage = ref("");
const expiryDays = computed(() => userDocument?.value?.ExpiryDays);
const secretKey = process.env.VUE_APP_ENCRYPT_DECRYPT_SECRET_KEY;
const JwtSecretKey = process.env.VUE_APP_JWT_KEY;
const errorFlag = ref(false);
const unAuthorizedFlag = ref(false);
const store = useStore();
const loader = ref(true);
const counting = ref(false);
const counDownTime = ref(0);
const { t } = useI18n();
const userDocument = ref<any | null>(null);
const invoiceDetail = ref<any | null>(null);
const downloadCount = computed(() => invoiceDetail?.value?.DownloadCount);
const remainingDownloads = computed(
  () => userDocument?.value?.MaxDownloads - invoiceDetail?.value?.DownloadCount
);
const invalidIDFlag = ref(false);
const baseUrl = process.env.VUE_APP_BASE_API_URL;
const route = useRoute();
const userId = ref(route.query.p as string);

// Captcha state and logic (copied from SubscriberPdfForm.vue)
const captchaInput = ref("");
const captchaText = ref("");
const captchaState = ref<boolean | null>(null);
const captchaError = ref<"empty" | "mismatch" | null>(null);
const handleCaptchaUpdate = (text: string) => {
  captchaText.value = text;
};

// countdown end handler
const onCountdownEnd = () => {
  counting.value = false;
  otpSentFlag.value = false;
  otpErrorFlag.value = true;
  otpPopUpErrorMessage.value = t("otpValidate.timeExpired");
  lastOtpErrorCode.value = "EB005";
};

// build readiness computed (enable button only when basic validation ok)
const isFormReady = computed(() => {
  // quick check to enable button (OTP length 6 + captcha filled)
  return (
    otp.value &&
    otp.value.trim().length === 6 &&
    captchaInput.value &&
    captchaInput.value === captchaText.value &&
    !loader.value
  );
});

const onOtpNext = () => {
  if (validateOtpForm()) {
    validateOtp();
  }
};

// validate OTP form + captcha
watch(otp, () => (otpState.value = null));

const validateOtpForm = () => {
  let isValid = true;
  if (!otp.value || otp.value.trim() === "") {
    otpState.value = false;
    otpError.value = "empty";
    otpErrorMessage.value = t("otpValidate.pleaseEnterOtp");
    isValid = false;
  } else if (otp.value.length < 6) {
    otpState.value = false;
    otpError.value = "invalid";
    otpErrorMessage.value = t("otpValidate.pleaseEnterDigit");
    isValid = false;
  } else {
    otpError.value = "";
    otpErrorMessage.value = "";
  }

  // captcha validation
  captchaState.value = captchaInput.value === captchaText.value;
  if (!captchaInput.value) {
    captchaError.value = "empty";
    captchaState.value = false;
    isValid = false;
  } else if (captchaInput.value !== captchaText.value) {
    captchaError.value = "mismatch";
    captchaState.value = false;
    isValid = false;
  } else {
    captchaError.value = null;
  }

  return isValid;
};

const validateOtp = async () => {
  counting.value = false;
  counDownTime.value = 0;
  try {
    loader.value = true;
    let token = getTokenFromSessionStorage();
    if (!token) {
      token = await getToken(token);
    }
    const encryptedDataValue = {
      userId: userId.value,
      otp: otp.value,
    };
    const checksumString = Object.values(encryptedDataValue).join("-");
    const checksum = generateChecksum(checksumString);
    const dataString = JSON.stringify(encryptedDataValue);
    const encryptedDataString = CryptoJS.AES.encrypt(
      dataString,
      secretKey
    ).toString();
    const response = await axios.post(
      `${baseUrl}/validate`,
      { encryptedDataString },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-Checksum": checksum,
        },
      }
    );

    const encryptedData = response.data;
    const decryptedText = decryptData(encryptedData);
    const receivedChecksum = response.headers["x-file-checksum"];
    const calculatedChecksum = generateChecksum(response.data);
    const OtpValidateData = JSON.parse(decryptedText);
    console.log("OTP Validate API Response:", OtpValidateData);
    if (
      receivedChecksum === calculatedChecksum &&
      OtpValidateData.UserId === userId.value
    ) {
      const status = OtpValidateData.Status;
      const otpData = OtpValidateData.OtpData || {};
      const code = otpData.code;

      if (status && status.toLowerCase() === "success") {
        //loader.value = true;
        //otpState.value = true;
        store.commit("setAuth", true);
        setTimeout(() => {
          router.push({
            name: "PDFInvoiceDownloadPage",
            query: { p: userId.value },
          });
        }, 0);
      } else {
        otpSentFlag.value = false;
        otpState.value = false;
        const remainingMs = computeRemainingMs(otpData.nextOtpAt);

        console.log("Time until next OTP (ms):", remainingMs);
        counDownTime.value = remainingMs;
        counting.value = remainingMs > 0;
        loader.value = false;
        switch (code) {
          case "EB004":
            lastOtpErrorCode.value = code;
            otpErrorFlag.value = true;
            otpPopUpErrorMessage.value = t("otpValidate.invalidCode");
            break;
          case "EB005":
            lastOtpErrorCode.value = code;
            otpErrorFlag.value = true;
            otpPopUpErrorMessage.value = t("otpValidate.codeExpired");
            break;
          case "EB006":
            lastOtpErrorCode.value = code;
            otpErrorFlag.value = true;
            otpPopUpErrorMessage.value = t("otpValidate.attemptLocked");
            break;
          default:
            lastOtpErrorCode.value = code;
            otpErrorFlag.value = true;
            otpPopUpErrorMessage.value = t(
              "otpValidate.unabletoprocesstherequest"
            );
            break;
        }
      }
    } else {
      loader.value = false;
      errorFlag.value = true;
    }
  } catch (error) {
    loader.value = false;
    console.error("OTP validation failed", error);
    otpState.value = false;
    otpErrorMessage.value = t("common.unableToProcess");
  }
  // finally {
  //   loader.value = false;
  // }
};

// re-used token, fetch and storage helpers (same as original)
const getInvoiceCount = async (token: any) => {
  const checksumString = `${userId.value}`;
  const checksum = generateChecksum(checksumString);
  try {
    const invoiceCountDetail = await axios.get(
      `${baseUrl}/invoice/count/${userId.value}`,
      {
        headers: { Authorization: `Bearer ${token}`, "X-Checksum": checksum },
      }
    );
    const encryptedData = invoiceCountDetail.data;
    const decryptedText = decryptData(encryptedData);
    const receivedChecksum = invoiceCountDetail.headers["x-file-checksum"];
    const calculatedChecksum = generateChecksum(invoiceCountDetail.data);
    const invoiceData = JSON.parse(decryptedText);
    if (
      receivedChecksum === calculatedChecksum &&
      invoiceData.UserId === userId.value
    ) {
      invoiceDetail.value = invoiceData;
      loader.value = false;
    } else {
      loader.value = false;
      errorFlag.value = true;
    }
  } catch (error: any) {
    loader.value = false;
    errorFlag.value = true;
    console.error("Failed to fetch invoice details:", error);
  }
};

const getToken = async (token: any) => {
  token = "";
  try {
    const encryptedDataValue = {
      UserId: userId.value,
      SecretKey: JwtSecretKey,
      timestamp: new Date().toISOString(),
    };
    const dataString = JSON.stringify(encryptedDataValue);
    const encryptedDataString = CryptoJS.AES.encrypt(
      dataString,
      secretKey
    ).toString();
    const tokenResponse = await axios.post(`${baseUrl}/auth/generate-token`, {
      encryptedDataString,
    });
    token = tokenResponse.data.token;
    setTokenInSessionStorage(token, 23);
    return token;
  } catch (error: any) {
    console.error("Failed to generate token:", error);
    if (error.response) {
      if (error.response.status === 404 || error.response.status === 401) {
        unAuthorizedFlag.value = true;
      } else {
        errorFlag.value = true;
        throw new Error("Failed to generate token. Please try again.");
      }
    }
  }
};

const setTokenInSessionStorage = (token: any, expiresIn: number) => {
  const expirationTime = Date.now() + expiresIn * 3600 * 1000;
  sessionStorage.setItem(`token_${userId.value}`, token);
  sessionStorage.setItem(
    `tokenExpiration_${userId.value}`,
    expirationTime.toString()
  );
};

const getTokenFromSessionStorage = () => {
  const token = sessionStorage.getItem(`token_${userId.value}`);
  const expirationTime = parseInt(
    sessionStorage.getItem(`tokenExpiration_${userId.value}`) || "0"
  );

  if (Date.now() > expirationTime) {
    sessionStorage.removeItem(`token_${userId.value}`);
    sessionStorage.removeItem(`tokenExpiration_${userId.value}`);
    return null;
  }

  return token;
};

/**
 * fetchUserData in OtpValidate:
 * - only fetch invoice metadata (no link-expiry/publicUrl routing here)
 * - HomePage handles expiry & publicUrl routing
 */
const fetchUserData = async () => {
  try {
    loader.value = true;
    let token = getTokenFromSessionStorage();

    if (!token) {
      token = await getToken(token);
    }
    const checksumString = `${userId.value}`;
    const checksum = generateChecksum(checksumString);

    const invoiceResponse = await axios.get(
      `${baseUrl}/invoice/${userId.value}`,
      {
        headers: { Authorization: `Bearer ${token}`, "X-Checksum": checksum },
      }
    );

    const encryptedData = invoiceResponse.data;
    const decryptedText = decryptData(encryptedData);
    const receivedChecksum = invoiceResponse.headers["x-file-checksum"];
    const calculatedChecksum = generateChecksum(invoiceResponse.data);
    const invoiceData = JSON.parse(decryptedText);

    if (
      receivedChecksum === calculatedChecksum &&
      invoiceData.UserId === userId.value
    ) {
      userDocument.value = invoiceData;
      store.commit("setUserID", userDocument.value.Id);
    } else {
      loader.value = false;
      errorFlag.value = true;
    }
    await getInvoiceCount(token);
  } catch (error: any) {
    console.error("Failed to fetch user data", error);
    if (error.response && error.response.status === 404) {
      invalidIDFlag.value = true;
      loader.value = false;
      throw new Error("User ID not found. Please check the ID and try again.");
    } else {
      errorFlag.value = true;
      loader.value = false;
      throw new Error("Failed to fetch user data. Please try again later.");
    }
  } finally {
    loader.value = false;
  }
};

onMounted(() => {
  fetchUserData();
});
// separate helper to compute remaining milliseconds until target time
const computeRemainingMs = (timestamp: string): number => {
  // API Timestamp "2025-11-20T22:32:55,741-05:00";

  if (!timestamp) return 0;

  // Normalize timestamp: replace first comma after seconds with a dot so JS can parse milliseconds
  const fixedTimestamp = timestamp.replace(",", ".");

  const targetDate = new Date(fixedTimestamp);
  if (isNaN(targetDate.getTime())) {
    console.warn("Failed to parse OTP timestamp:", timestamp);
    return 0;
  }

  const now = new Date();
  return Math.max(0, targetDate.getTime() - now.getTime());
};
const requestVerificationCode = async () => {
  loader.value = true;
  otpErrorFlag.value = false;
  otp.value = "";
  otpState.value = null;
  captchaInput.value = "";
  captchaState.value = null;
  const checksumString = `${userId.value}`;
  const checksum = generateChecksum(checksumString);
  let token = getTokenFromSessionStorage();
  if (!token) {
    token = await getToken(token);
  }
  try {
    const otpDetails = await axios.get(`${baseUrl}/generate/${userId.value}`, {
      headers: { Authorization: `Bearer ${token}`, "X-Checksum": checksum },
    });
    const encryptedData = otpDetails.data;
    const decryptedText = decryptData(encryptedData);
    const receivedChecksum = otpDetails.headers["x-file-checksum"];
    const calculatedChecksum = generateChecksum(otpDetails.data);
    const otpData = JSON.parse(decryptedText);
    if (
      receivedChecksum === calculatedChecksum &&
      otpData.UserId === userId.value
    ) {
      if (otpData.Status.toLowerCase() === "success") {
        loader.value = false;
        otpSentFlag.value = true;
        const est = new Date().toLocaleString("en-US", {
          timeZone: "America/New_York",
        });
        console.log("OTP next at (EST):", otpData.OtpData.nextOtpAt);
        console.log("OTP sent at (EST):", est);

        const remainingMs = computeRemainingMs(otpData.OtpData.nextOtpAt);

        console.log("Time until next OTP (ms):", remainingMs);
        counDownTime.value = remainingMs;
        counting.value = remainingMs > 0;
      } else {
        otpErrorMessage.value = otpData.OtpData.errorReason;
        loader.value = false;
        otpErrorFlag.value = true;
        return;
      }
    } else {
      loader.value = false;
      errorFlag.value = true;
    }
  } catch (error: any) {
    loader.value = false;
    errorFlag.value = true;
    console.error("Failed to fetch Otp details:", error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_b_navbar_brand = _resolveComponent("b-navbar-brand")!
  const _component_b_navbar = _resolveComponent("b-navbar")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_b_navbar, {
      toggleable: "",
      type: "light",
      variant: "light",
      class: "p-3"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_b_navbar_brand, { class: "title" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("titleInvoice")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    (loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_b_spinner, {
            style: {"width":"6rem","height":"6rem","color":"#003778"},
            label: "Large Spinner"
          })
        ]))
      : _createCommentVNode("", true),
    (invalidIDFlag.value || errorFlag.value || unAuthorizedFlag.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (unAuthorizedFlag.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_unref(t)("form.unauthorized")), 1))
            : _createCommentVNode("", true),
          (invalidIDFlag.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_unref(t)("form.invalidrequest")), 1))
            : _createCommentVNode("", true),
          (errorFlag.value && !unAuthorizedFlag.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_unref(t)("form.unabletoprocesstherequest")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!loader.value && !invalidIDFlag.value && !errorFlag.value && !unAuthorizedFlag.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_unref(t)("form.expirydaysmessageInvoice")) + " ", 1),
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_unref(t)("form.expirydaysmessageInvoiceDay")) + " ", 1),
            _createElementVNode("a", _hoisted_9, _toDisplayString(expiryDays.value) + " " + _toDisplayString(_unref(t)("form.days")), 1),
            _createTextVNode(". ")
          ]),
          _hoisted_10,
          _createVNode(_component_b_form_group, {
            "label-for": "otp-input",
            "label-class": "custom-label"
          }, {
            default: _withCtx(() => [
              _createElementVNode("label", {
                class: "custom-label",
                state: otpState.value
              }, _toDisplayString(_unref(t)("otpValidate.verificationCode")), 9, _hoisted_11),
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_b_col, {
                  sm: "4",
                  class: "otp-input-container"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_form_input, {
                      id: "otp-input",
                      modelValue: otp.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((otp).value = $event)),
                      maxlength: "6",
                      placeholder: _unref(t)('otpValidate.verificationCode'),
                      state: otpState.value,
                      class: "custom-placeholder",
                      required: ""
                    }, null, 8, ["modelValue", "placeholder", "state"]),
                    _createVNode(_component_b_form_invalid_feedback, {
                      state: otpState.value,
                      class: "d-block"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(otpErrorMessage.value), 1)
                      ]),
                      _: 1
                    }, 8, ["state"]),
                    (otpSentFlag.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _hoisted_15,
                          _createTextVNode(" " + _toDisplayString(_unref(t)("otpValidate.codeSent")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (otpErrorFlag.value && otpPopUpErrorMessage.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _hoisted_17,
                          _createTextVNode(" " + _toDisplayString(otpPopUpErrorMessage.value), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["request-code-link", { 'disabled-link': counting.value }]),
                        "aria-disabled": counting.value,
                        tabindex: counting.value ? -1 : 0,
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (!counting.value && requestVerificationCode()), ["prevent"]))
                      }, _toDisplayString(_unref(t)("otpValidate.requestVerificationCode")), 11, _hoisted_20),
                      (counting.value)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_21, [
                            _createTextVNode(_toDisplayString(_unref(t)("otpValidate.codeExpireIn")) + ": ", 1),
                            _hoisted_22,
                            _createVNode(_unref(VueCountdown), {
                              time: counDownTime.value,
                              format: "mm:ss",
                              onEnd: onCountdownEnd
                            }, {
                              default: _withCtx(({ minutes, seconds }) => [
                                _createTextVNode(_toDisplayString(String(minutes).padStart(2, "0")) + ":" + _toDisplayString(String(seconds).padStart(2, "0")), 1)
                              ]),
                              _: 1
                            }, 8, ["time"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_b_form_group, {
            label: _unref(t)('form.captcha'),
            "label-for": "captcha-input",
            class: "custom-label mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, { sm: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_input, {
                    id: "captcha-input",
                    type: "text",
                    placeholder: _unref(t)('form.entercaptcha'),
                    modelValue: captchaInput.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((captchaInput).value = $event)),
                    state: captchaState.value,
                    class: "custom-placeholder",
                    required: ""
                  }, null, 8, ["placeholder", "modelValue", "state"]),
                  (captchaError.value)
                    ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                        key: 0,
                        state: captchaState.value,
                        class: "d-block"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.captchaErrorMessage), 1)
                        ]),
                        _: 1
                      }, 8, ["state"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _hoisted_23,
              _createVNode(Recaptcha, { onCaptchaUpdated: handleCaptchaUpdate })
            ]),
            _: 1
          }, 8, ["label"]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_b_button, {
              variant: "primary",
              class: "next-button me-3",
              onClick: onOtpNext,
              disabled: !isFormReady.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("otpValidate.download")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _hoisted_25,
          _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(t)("download.previousdownloads")) + ": " + _toDisplayString(downloadCount.value), 1),
          _hoisted_27,
          _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(t)("download.remainingdownloads")) + ": " + _toDisplayString(remainingDownloads.value), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})